export const getInitialState = (): any => ({
  datasourceUsersData: []
});
